import { useEventListener } from '@nike/privacy-shared-react';
import type { ContextFrameNamesModal } from '@nike/privacy-types';

import {
  getPrivacyCoreCustomEventNames,
  getInlineCustomEventNames,
} from '../helpers/customEventNames';

/**
 * @name useUpdateErrorListener
 * @description - Custom hook which listen update errors
 * @param {function} handler - Will be run when an error happens
 * @param {ContextFrameNamesModal | undefined} contextFrameName - a namespace to retrieve interactions from
 * @returns {void}
 */
export const useUpdateErrorListener = (
  handler: () => void,
  contextFrameName: ContextFrameNamesModal | undefined,
): void => {
  const privacyCoreCustomEventNames = getPrivacyCoreCustomEventNames(contextFrameName);
  const inlineCookieCustomEventNames = getInlineCustomEventNames(contextFrameName);

  useEventListener(privacyCoreCustomEventNames.PERMISSIONS_UPDATE_ERROR, () => {
    handler();
  });

  useEventListener(inlineCookieCustomEventNames.PERMISSIONS_UPDATE_ERROR, () => {
    handler();
  });
};
